import { BaSeDialogContext } from '@base/react';
import * as React from 'react';

export const useMessage = () => {
  const { showNotification } = React.useContext(BaSeDialogContext);

  const handleError = React.useCallback(
    (msg) =>
      showNotification({
        message: 'Erro!',
        supportMessage: msg,
        secondsToClose: 5,
        color: 'destructive',
      }),
    [showNotification],
  );

  const handleSuccess = React.useCallback(
    (msg) =>
      showNotification({
        message: 'Sucesso!',
        supportMessage: msg,
        secondsToClose: 5,
        color: 'confirmation',
      }),
    [showNotification],
  );

  const handleCustomSuccess = React.useCallback(
    (title, msg) =>
      showNotification({
        message: title,
        supportMessage: msg,
        secondsToClose: 10,
        color: 'confirmation',
      }),
    [showNotification],
  );

  const handleCustomAlert = React.useCallback(
    (title, msg) =>
      showNotification({
        message: title,
        supportMessage: msg,
        secondsToClose: 1.2,
        color: 'default',
      }),
    [showNotification],
  );

  const handleAttention = React.useCallback(
    (msg) =>
      showNotification({
        message: 'Atenção!',
        supportMessage: msg,
        secondsToClose: 5,
        color: 'attention',
      }),
    [showNotification],
  );

  const handleAttentionFast = React.useCallback(
    (msg) =>
      showNotification({
        message: 'Atenção!',
        supportMessage: msg,
        secondsToClose: 4,
        color: 'attention',
      }),
    [showNotification],
  );

  return {
    handleError,
    handleSuccess,
    handleAttention,
    handleCustomSuccess,
    handleCustomAlert,
    handleAttentionFast,
  };
};
